export const MeditatorTabs = {
    registered_meditators: "registered_meditators",
    new_registrants: "new_registrants",
    old_registrants: "old_registrants",
}

export const RegistrantTypes = {
    NEW: "New Registrant",
    OLD: "Old Registrant"
}